import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';

@Component({
    selector: 'xqnr-suggestions',
    templateUrl: './suggestions.component.pug',
    styleUrls: ['./suggestions.component.scss'],
    standalone: false
})
export class SuggestionsComponent implements OnInit {
  suggestionList = [];
  suggestionList$ = new Subject();

  constructor(
    public suggestions: SuggestionService,
    private backdrop: BackdropService
  ) {}

  ngOnInit(): void {
    this.suggestionsUpdated();

    this.suggestionList = this.suggestions.currentSuggestions;

    this.suggestions.active$.subscribe(() => this.suggestionsUpdated());

    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (activeState === false) this.suggestions.hide();
    });
  }

  suggestionsUpdated() {
    this.suggestionList$.next(null);
    this.suggestionList = this.suggestions.currentSuggestions;
  }

  hideSuggestions() {
    this.suggestions.hide();
    this.backdrop.hide();
  }

  carouseClick(e: any) {
    e.preventDefault();
    e.stopPropagation();
  }

  searchActionReceived() {
    this.suggestions.hide();
    this.backdrop.hide();
  }
}
